import { render, staticRenderFns } from "./IpoOrderHistory.vue?vue&type=template&id=17709a3b"
import script from "./IpoOrderHistory.vue?vue&type=script&lang=js"
export * from "./IpoOrderHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports